var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiw4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 174,
    viewBox: "0 0 280 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 279,
    height: 173,
    rx: 12.5,
    fill: "white",
    stroke: "#2B2BCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 38,
    width: 107,
    height: 17,
    fill: "#2B2BCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.999 83.9996C51.354 84.0846 59.984 74.1996 59.899 63.5096C59.8165 52.8246 51.354 44.0846 40.999 43.9996C30.644 43.9146 22.3165 52.5096 22.399 63.1996C22.4865 73.8846 30.6465 83.9096 40.999 83.9996Z",
    fill: "#DFFC6B",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7498 61.5C49.7271 59.5179 48.9296 57.6235 47.528 56.2218C46.1263 54.8202 44.2319 54.0227 42.2498 54M40.9998 89.875C41.8023 89.875 42.2048 89.875 42.4823 89.82C44.1173 89.5 45.1098 87.89 44.6273 86.345C44.5448 86.0825 44.3548 85.74 43.9748 85.0575M40.9998 89.875C40.1973 89.875 39.7948 89.875 39.5173 89.82C37.8823 89.5 36.8898 87.89 37.3723 86.345C37.4548 86.0825 37.6448 85.74 38.0248 85.0575M40.9998 89.875V95.25",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 69,
    width: 165,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 84,
    width: 165,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 99,
    width: 165,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 124,
    width: 52,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 124,
    width: 52,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiw4);
export default __webpack_public_path__ + "static/media/HIW-4.3266f4b93f45f61d8325a67a4388546b.svg";
export { ForwardRef as ReactComponent };